import request from '@/utils/request'

/* 
获取币种列表
*/

export function getCoinsList() {
  return request({
    url: '/api/approval/icons',
    method: 'get',
  })
}

/**
 * 提交评论
 */
export function postComment(id, comment, img_keys) {
  return request({
    url: '/api/approval/approval_comment',
    method: 'post',
    params: {
      id,
    },
    data: {
      content: comment,
      img_keys,
    },
  })
}
/**
 * 提交抄送
 */
export function copyToPerson(id, reason, viewers) {
  return request({
    url: '/api/approval/copy_to',
    method: 'post',
    params: {
      id,
    },
    data: {
      reason,
      viewers,
    },
  })
}
/**
 * 获取审批流列表
 */
export function getApprovalList() {
  return request({
    url: '/api/approval/approval_basics/list',
    method: 'get',
  })
}

/**
 * 获取审批流基本信息详情
 */
export function getApprovalBasicDetail(type) {
  return request({
    url: '/api/approval/approval_basics',
    method: 'get',
    params: {
      type,
    },
  })
}

/**
 * 保存审批路基本信息详情
 */
export function saveApprovalBasicDetail(type, data) {
  return request({
    url: '/api/approval/approval_basics',
    method: 'put',
    params: {
      type,
    },
    data,
  })
}

/**
 * 获取审批流节点
 */
export function getAprovalNodes(type) {
  return request({
    url: '/api/approval/approval-nodes',
    method: 'get',
    params: {
      type,
    },
  })
}

/**
 * 保存审批流节点
 */
export function saveApprovalNodes(type, data) {
  return request({
    url: '/api/approval/approval-nodes/save-nodes',
    method: 'post',
    data,
    params: {
      type,
    },
  })
}

/**
 * 创建审批实例（报销）
 */
export function createApprovalInstance(type, data) {
  return request({
    url: '/api/approval/approval-instances',
    method: 'post',
    params: {
      type,
    },
    data,
  })
}

/**
 * 获取审批实例记录列表
 */
export function getApprovalInstances(params, cancelToken) {
  return request({
    url: '/api/approval/approval-instances/list',
    method: 'get',
    params,
    cancelToken,
  })
}

/**
 * 获取审批实例记录详情
 */
export function getApprovalInstanceDetail(id) {
  return request({
    url: '/api/approval/approval-instances',
    method: 'get',
    params: { id },
  })
}

/**
 * 任务（允许，拒绝）
 */
export function approvalInstanceTask(id, status) {
  return request({
    url: '/api/approval/approval-tasks',
    method: 'put',
    params: {
      id,
    },
    data: {
      status,
    },
  })
}
/**
 * 任务（撤回）
 */
export function cancelInstanceTask(id, status) {
  return request({
    url: '/api/approval/approval-tasks/cancel-instance',
    method: 'put',
    params: {
      id,
    },
  })
}

/**
 * 保存修改附属表单
 */
export function approvalInstanceAttachFormTask(id, data) {
  return request({
    url: '/api/approval/approval-tasks/attach-form',
    method: 'post',
    params: {
      id,
    },
    data,
  })
}
/**
 * 修改原始表单
 */
export function modifyOriginalFrom(id, data) {
  return request({
    url: '/api/approval/approval-tasks/modify-form',
    method: 'put',
    params: {
      id,
    },
    data,
  })
}

/**
 * 获取审批实例记录详情
 */
export function getApprovalInstance(id) {
  return request({
    url: '/api/approval/approval-instances',
    method: 'get',
    params: {
      id,
      sort: 'created_at',
    },
  })
}

/**
 * 获取审批流实力统计列表
 */
export function getApprovalInstanceCountList(params) {
  return request({
    url: '/api/approval/approval-instance/count',
    method: 'get',
    params,
  })
}

/**
 * 获取审批实例记录详情
 */
export function getExpenseTypeList() {
  return request({
    url: '/api/approval/approval-instances/expense-type-list',
    method: 'get',
  })
}
/**
 * 获取发票类型
 */
export function getInvoiceTypeList() {
  return request({
    url: '/api/approval/approval-instances/ocr-type',
    method: 'get',
  })
}
/**
 * 通过上传图片得到的key获取图片
 */
export function getImgByKey(key) {
  return request({
    url: '/api/approval/approval-instances/get-attach',
    method: 'get',
    params: {
      key,
    },
  })
}

/**
 * 获取我可发起的审批列表
 */
export function getMyApprovals() {
  return request({
    url: '/api/approval/approval_basics/initiator-index',
    method: 'get',
  })
}

// 采购账单列表
export function getRelativeBills(
  basic_type,
  other_company_id,
  purchase_bill_ids,
) {
  return request({
    url: '/api/approval/approval_basics/bills',
    method: 'get',
    params: {
      type: basic_type,
      other_company_id,
      purchase_bill_ids,
    },
  })
}

// 采购账单详情
export function getBillDetail(purchase_bill_ids) {
  return request({
    url: '/api/approval/approval_basics/bill-detail',
    method: 'get',
    params: {
      purchase_bill_ids,
    },
  })
}

// 费用部门列表
export function getDepartmentList() {
  return request({
    url: '/api/approval/approval_basics/department',
    method: 'get',
  })
}

// 银行类型列表
export function getBankType(params) {
  return request({
    url: '/api/approval/approval-instance/bank_type',
    method: 'get',
  })
}
